<jhi-custom-box
    [title]="'spans.firstLogin.boxtitle'"
    [requiredFields]="true"
    [translateParams]="{username: fUsername?.value}"
    [boxSize]="'box-550'"
    [successMsg]="successMsg"
    (successEmitter)="doRedirect()"
    (failureEmitter)="doRedirect()"
    [errorMsg]="errorMsg"
>

    <div class="row p-0 mb-3">
        <div class="col-12 text-center">
            <span class="text-orange" jhiTranslate="spans.firstLogin.mandatoryChange"></span>
            <br>
            <span class="text-orange" jhiTranslate="spans.firstLogin.reauth"></span>
        </div>
    </div>

    <div class="row p-0 mb-3">
        <div class="col-12 text-center">
            <a placement="right" class="blue-anchor" [autoClose]="'inside'" container="body" popoverClass="popover-position-fix" [ngbPopover]="popContent" popoverTitle="{{'spans.changePassword.passwordRules' | translate}}" jhiTranslate="spans.changePassword.passwordRules">
            </a>
        </div>
    </div>

    <form [formGroup]="userForm" (ngSubmit)="onSubmit()">

        <div class="form-group">
            <div class="row">
                <div class="col-4 text-right mb-auto mt-auto">
                    <label class="mb-0" for="username-input" jhiTranslate="spans.firstLogin.formlabels.username"> Username </label>
                </div>

                <div class="col-8">
                    <input [readOnly]="true" id="username-input" type="text" [formControlName]="'username'" class="form-control"/>
                </div>
            </div>

            <div class="row m-t-5">
                <div class="col-4 text-right mb-auto mt-auto">
                    <label class="mb-0" for="oldpassword-input" jhiTranslate="spans.firstLogin.formlabels.oldPassword"> Old password </label>
                </div>
                <div class="col-8 d-flex">
                    <input [readOnly]="submitted" [type]="showOldPassword ? 'text' : 'password'" [placeholder]="'spans.firstLogin.formplaceholders.oldPassword' | translate" id="oldpassword-input"  [formControlName]="'oldPassword'" class="form-control" [ngClass]="errorCheck && f.oldPassword.errors ? 'is-invalid': ''" />
                    <div class="input-group-append">
                        <button title="{{'spans.firstLogin.showOldPassword' | translate}}" type="button" class="btn btn-outline-secondary" (click)="changeShowOldPassword()">
                            <fa-icon [icon]="faEyeSlash"></fa-icon>
                        </button>
                    </div>
                </div>
                <div class="col-4"></div>
                <div class="col-8 align-self-end">
                    <div *ngIf="errorCheck && fOldPassword.invalid" class="error-box">
                        <span *ngIf="errorCheck && fOldPassword.errors?.required" jhiTranslate="spans.firstLogin.formerrors.requiredOldPassword"> Old password required </span>
                    </div>
                </div>
            </div>

            <div class="row m-t-5">
                <div class="col-4 text-right mb-auto mt-auto">
                    <label class="mb-0" for="newpassword-input" jhiTranslate="spans.firstLogin.formlabels.newPassword"> New password </label>
                </div>
                <div class="col-8 d-flex">
                    <input [readOnly]="submitted" [type]="showNewPassword ? 'text' : 'password'" [placeholder]="'spans.firstLogin.formplaceholders.newPassword' | translate" id="newpassword-input" [formControlName]="'newPassword'" class="form-control" [ngClass]="errorCheck && f.newPassword.errors ? 'is-invalid': ''" />
                    <div class="input-group-append">
                        <button title="{{'spans.firstLogin.showNewPassword' | translate}}" type="button" class="btn btn-outline-secondary" (click)="changeShowNewPassword()">
                            <fa-icon [icon]="faEyeSlash"></fa-icon>
                        </button>
                    </div>
                </div>
                <div class="col-4"></div>
                <div class="col-8 align-self-end">
                    <div *ngIf="errorCheck && fNewPassword.invalid" class="error-box">
                        <span *ngIf="errorCheck && fNewPassword.errors?.required" jhiTranslate="spans.firstLogin.formerrors.requiredNewPassword"> Old password required </span>
                    </div>
                </div>
            </div>

            <div class="row m-t-5">
                <div class="col-4 text-right mb-auto mt-auto">
                    <label class="mb-0" for="cnewpassword-input" jhiTranslate="spans.firstLogin.formlabels.confirmNewPassword"> Confirm new password </label>
                </div>
                <div class="col-8 input-group">
                    <input [readOnly]="submitted" [type]="showConfirmNewPassword ? 'text' : 'password'" [placeholder]="'spans.firstLogin.formplaceholders.confirmNewPassword' | translate" id="cnewpassword-input" type="email" [formControlName]="'confirmNewPassword'" class="form-control" [ngClass]="errorCheck && f.confirmNewPassword.errors ? 'is-invalid': ''" />
                    <div class="input-group-append">
                        <button title="{{'spans.firstLogin.showConfirmNewPassword' | translate}}" type="button" class="align-self-start btn btn-outline-secondary" (click)="changeShowConfirmNewPassword()">
                            <fa-icon [icon]="faEyeSlash"></fa-icon>
                        </button>
                    </div>
                </div>
                <div class="col-4"></div>
                <div class="col-8 align-self-end">
                    <div *ngIf="errorCheck && fConfirmNewPass.invalid" class="error-box">
                        <span *ngIf="errorCheck && fConfirmNewPass.errors?.required" jhiTranslate="spans.firstLogin.formerrors.requiredConfirmNewPassword"> Old password required </span>
                    </div>
                </div>
            </div>


            <div class="row m-t-5">
                <div class="col-4 text-right mb-auto mt-auto">
                    <label class="mb-0" for="email-input" jhiTranslate="spans.firstLogin.formlabels.email"> email </label>
                </div>
                <div class="col-8 d-flex">
                    <input [readOnly]="submitted" [placeholder]="'spans.firstLogin.formplaceholders.email' | translate" id="email-input" type="email" [formControlName]="'email'" class="form-control" [ngClass]="errorCheck && f.email.errors ? 'is-invalid': ''" />
                    <svg [ngClass]="verifiedEmail ? 'green-check-icon' : 'red-check-icon'"><use xlink:href="../../../../content/svg/sprite.svg#it-check-circle"></use>
                        <title>{{(verifiedEmail ? 'spans.common.verifiedMail' : 'spans.common.notVerifiedMail') | translate}}</title>
                    </svg>
                </div>
                <div class="col-4"></div>
                <div class="col-8">
                    <div *ngIf="errorCheck && fEmail.invalid" class="error-box">
                        <span *ngIf="errorCheck && fEmail.errors?.required" jhiTranslate="spans.firstLogin.formerrors.requiredEmail"> Email required </span>
                    </div>
                </div>
            </div>

            <div class="row m-t-5">
                <div class="col-4 text-right mb-auto mt-auto">
                    <label class="mb-0" for="altEmail-input" jhiTranslate="spans.firstLogin.formlabels.altEmail"> Alt email </label>
                </div>
                <div class="col-8">
                    <input id="altEmail-input" type="text" [formControlName]="'altEmail'" class="form-control" />
                </div>
                <div *ngIf="this.userForm.get('email').value === this.userForm.get('altEmail').value" class="error-box">
                    <span *ngIf="this.userForm.get('email').value === this.userForm.get('altEmail').value" jhiTranslate="spans.firstLogin.formerrors.emailEquals"> Invalid email </span>
                </div>
            </div>


            <div class="row m-t-5">
                <div class="col-4 text-right mb-auto mt-auto">
                    <label class="mb-0" for="phone-input" jhiTranslate="spans.editAccountInfo.formlabels.mobilePhone"> Mobile phone </label>
                </div>
                <div class="col-8 d-flex">
                    <span class="m-r-10 mt-auto mb-auto" jhiTranslate="spans.common.ITphonePrefix">(+39)</span>
                    <input [readOnly]="submitted" [placeholder]="'spans.editAccountInfo.formplaceholders.mobilePhone' | translate" id="phone-input" type="number" [formControlName]="'phone'" class="align-self-center form-control" [ngClass]="errorCheck && f.phone.errors ? 'is-invalid': ''" />
                    <svg [ngClass]="verifiedPhone ? 'green-check-icon' : 'red-check-icon'"><use xlink:href="../../../../content/svg/sprite.svg#it-check-circle"></use>
                        <title>{{(verifiedPhone ? 'spans.common.verifiedPhone' : 'spans.common.notVerifiedPhone') | translate}}</title>
                    </svg>
                </div>
                <div class="col-4"></div>
                <div class="col-8">
                    <div *ngIf="errorCheck && fPhone.invalid" class="error-box">
                        <span *ngIf="errorCheck && fPhone.errors?.required" jhiTranslate="spans.editAccountInfo.formerrors.requiredMobilePhone"> Phone required </span>
                    </div>
                </div>
            </div>




            <div class="row m-t-5">
                <div class="col-4 text-right mb-auto mt-auto">
                    <label class="mb-0" for="question-input" jhiTranslate="spans.firstLogin.formlabels.question"> Question </label>
                </div>
                <div class="col-8">
                    <input [readOnly]="submitted" [placeholder]="'spans.firstLogin.formplaceholders.question' | translate" id="question-input" type="text" [formControlName]="'question'" class="form-control" [ngClass]="errorCheck && f.question.errors ? 'is-invalid': ''" />
                </div>
                <div class="col-4"></div>
                <div class="col-8 align-self-end">
                    <div *ngIf="errorCheck && fQuestion.invalid" class="error-box">
                        <span *ngIf="errorCheck && fQuestion.errors?.required" jhiTranslate="spans.firstLogin.formerrors.requiredQuestion"> Question required </span>
                    </div>
                </div>
            </div>


            <div class="row m-t-5">
                <div class="col-4 text-right mb-auto mt-auto">
                    <label class="mb-0" for="answer-input" jhiTranslate="spans.firstLogin.formlabels.answer"> Answer </label>
                </div>
                <div class="col-8 input-group">
                    <input [readOnly]="submitted" [placeholder]="'spans.firstLogin.formplaceholders.answer' | translate" id="answer-input" [type]="showAnswer ? 'text' : 'password'" [formControlName]="'answer'" class="form-control" [ngClass]="errorCheck && f.answer.errors ? 'is-invalid': ''" />
                    <div class="input-group-append">
                        <button title="{{'spans.firstLogin.showAnswer' | translate}}" type="button" class="btn btn-outline-secondary" (click)="changeShowAnswer()">
                            <fa-icon [icon]="faEyeSlash"></fa-icon>
                        </button>
                    </div>
                </div>
                <div class="col-4"></div>
                <div class="col-8 align-self-end">
                    <div *ngIf="errorCheck && fAnswer.invalid" class="error-box">
                        <span *ngIf="errorCheck && fAnswer.errors?.required" jhiTranslate="spans.firstLogin.formerrors.requiredAnswer"> Answer required </span>
                    </div>
                </div>
            </div>
        </div>


        <div class="row text-center d-flex">
            <div class="col-12">
                <button [disabled]="submitted" type="button" class="btn secondary-btn" (click)="backToApp()" jhiTranslate="buttons.returntoapp">Return to application</button>
                <button [disabled]="submitted" (click)="onReset()" class="btn secondary-btn" jhiTranslate="buttons.discard">Discard</button>
                <button [ladda]="submitted" class="btn confirm-btn ladda-button max-w-120" data-style="expand-right">
                    <span class="ladda-label" jhiTranslate="buttons.submit"></span>
                </button>
            </div>

        </div>
    </form>
</jhi-custom-box>

<ng-template #popContent>
    <div class="p-0">
        <span jhiTranslate="spans.changePassword.rules.must"> must </span>
        <ul>
            <li jhiTranslate="spans.changePassword.rules.oneNumber"> one numeric </li>
            <li jhiTranslate="spans.changePassword.rules.oneUpper"> one uppercase </li>
            <li jhiTranslate="spans.changePassword.rules.oneSpecial"> one special char </li>
            <li jhiTranslate="spans.changePassword.rules.startAlphabet"> start with alphabet </li>
            <li jhiTranslate="spans.changePassword.rules.different"> different from user - first name - last name </li>
        </ul>
    </div>
</ng-template>
